import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getProductWarehouse(params) {
	return client.get("api/purchase-order-stockist/data_product_warehouse", {
		params: params,
	});
}

function saveProductPOStockist(params) {
	return client.post("api/purchase-order-stockist/save_product_po_stockist", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getMinimumBV() {
	return client.get("api/purchase-order-stockist/get_minimum_bv", {});
}

function saveMinimumBV(params) {
	return client.post("api/purchase-order-stockist/save_minimum_bv_po_stockist", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getProgressivePrice() {
	return client.get("api/purchase-order-stockist/get_progressive_price", {});
}

function saveProgressivePrice(params) {
	return client.post("api/purchase-order-stockist/save_progressive_price", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getProductWarehouse,
	saveProductPOStockist,
	getMinimumBV,
	saveMinimumBV,
	getProgressivePrice,
	saveProgressivePrice
};